import { render, staticRenderFns } from "./MailboxPicker.vue?vue&type=template&id=84d66076&scoped=true&"
import script from "./MailboxPicker.vue?vue&type=script&lang=js&"
export * from "./MailboxPicker.vue?vue&type=script&lang=js&"
import style0 from "./MailboxPicker.vue?vue&type=style&index=0&id=84d66076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d66076",
  null
  
)

export default component.exports